/**
 * BUG-112 — what the amplification rule editor keeps from a step.
 *
 * A step is an account, an offset and a time. The editor shows exactly
 * those, so it sends exactly those: anything else a stored step carries —
 * an old `amplifier_slug`, a pre-S-401 `platform` — is dropped on load and
 * again on save, where it can't silently override the account on screen.
 *
 * The one exception is `linkedin_article`, the LinkedIn newsletter's
 * companion post (bin/migrate-amplification-rule-to-accounts.ts); it is kept
 * and the editor labels it.
 */
export const LINKEDIN_ARTICLE_PLATFORM = "linkedin_article";

export interface EditableStep {
  account_id: number | undefined;
  platform?: typeof LINKEDIN_ARTICLE_PLATFORM;
  offset_days?: number;
  time_of_day?: string;
}

export function toEditableStep(stored: object): EditableStep {
  const step = stored as Record<string, unknown>;
  const out: EditableStep = { account_id: typeof step.account_id === "number" ? step.account_id : undefined };
  if (step.platform === LINKEDIN_ARTICLE_PLATFORM) out.platform = LINKEDIN_ARTICLE_PLATFORM;
  if (typeof step.offset_days === "number") out.offset_days = step.offset_days;
  if (typeof step.time_of_day === "string") out.time_of_day = step.time_of_day;
  return out;
}
